import { IManualCheckDisbursementData } from '../../IManualCheckDisbursementData';
import { eManualCheckDisbursementCategory } from '../../../../accounting/eManualCheckDisbursementCategory';
import {
  convertIPropertyAddressDataToIPropertyAddressRequest,
  IPropertyAddressRequest,
} from '../../../../address/IPropertyAddressRequest';

export interface IManualCheckDisbursementPostData {
  amountCents?: number;
  name?: string;
  memo?: string;
  category?: eManualCheckDisbursementCategory;
  mailingAddress?: IPropertyAddressRequest;
  cdItemV3Id?: string;
}

export const convertIManualCheckDisbursementDataToIManualCheckDisbursementPostData = ({
  amountCents,
  name,
  memo,
  category,
  mailingAddress,
  cdItemId,
}: IManualCheckDisbursementData): IManualCheckDisbursementPostData => ({
  amountCents,
  name,
  memo,
  category,
  mailingAddress: mailingAddress && convertIPropertyAddressDataToIPropertyAddressRequest(mailingAddress),
  cdItemV3Id: cdItemId,
});
